import { Route, Switch } from 'react-router-dom';

import {
  AdvancedApiRoutes,
  AdvancedApiRoutesConfig,
} from 'domains/advancedApi/routes';
import { AuthPageContainer } from 'domains/auth/screens/AuthPage';
import { BillingPageContainer } from 'domains/account/screens/BillingPage';
import { CardPaymentFailurePageContainer } from 'domains/account/screens/CardPaymentFailure';
import { CardPaymentSuccessPageContainer } from 'domains/account/screens/CardPaymentSuccessPage';
import { ChainPageContainer } from 'domains/chains/screens/ChainPage';
import { ChainsListPageContainer } from 'domains/chains/screens/ChainsListPage';
import { ConnectWalletCard } from 'domains/userSettings/components/ConnectWalletCard';
import { DashboardPageContainer } from 'domains/dashboard/screens/DashboardPage';
import { GuardAuthUserSettingsRoute } from 'domains/userSettings/components/GuardAuthUserSettingsRoute';
import { GuardEmailConfirmationRoute } from 'domains/userSettings/components/GuardEmailConfirmationRoute';
import { GuardSlackConfirmationRoute } from 'domains/userSettings/components/GuardSlackConfirmationRoute';
import { GuardTeamInvitationRoute } from 'domains/userSettings/components/GuardTeamInvitationRoute';
import { GuardTelegramConfirmationRoute } from 'domains/userSettings/components/GuardTelegramConfirmationRoute';
import { NewProjectPageContainer } from 'domains/projects/screens/NewProjectPage';
import { NewTeamPageContainer } from 'domains/teams/screens/NewTeamPage/NewTeamPageContainer';
import { NotificationsPageContainer } from 'domains/notifications/screens/NotificationsPage';
import { OAuthPageContainer } from 'domains/oauth/screens/OauthPage';
import { PageNotFound } from 'modules/router/components/PageNotFound';
import { PlatformSwaggerPageContainer } from 'domains/platformSwagger/screens/PlatformSwaggerPage';
import { PricingPageContainer } from 'domains/pricing/screens/PricingPage';
import { ProjectsParamsResolver } from 'domains/projects/routes/components/ProjectsParamsResolver';
import { ReferralsPageContainer } from 'domains/referrals/screens/ReferralsPage';
import { SwaggerUIPageContainer } from 'domains/swaggerUI/screens/SwaggerUIPage';
import { TeamsPageContainer } from 'domains/teams/screens/TeamsPage';
import { UserSettingsRoutesConfig } from 'domains/userSettings/Routes';
import { authRoutesConfig } from 'domains/auth/routes';
import { billingRoutesConfig } from 'domains/account/routes';
import { chainsRoutesConfig } from 'domains/chains/routes';
import { dashboardRoutesConfig } from 'domains/dashboard/routes';
import { notificationsRoutesConfig } from 'domains/notifications/routes';
import { oAuthRoutesConfig } from 'domains/oauth/routes';
import { platformSwaggerRoutesConfig } from 'domains/platformSwagger/routes';
import { pricingRoutesConfig } from 'domains/pricing/routes';
import { projectsRoutesConfig } from 'domains/projects/routes';
import { referralsRoutesConfig } from 'domains/referrals/routes';
import { swaggerUIRoutesConfig } from 'domains/swaggerUI/routes/constants';
import { teamsRoutesConfig } from 'domains/teams/routes';
import { getDevRoutes } from 'modules/dev';
import { featureConfig } from 'modules/common/featureConfig';

const settingsPaths = [
  UserSettingsRoutesConfig.settings.path,
  UserSettingsRoutesConfig.confirmation.path,
  UserSettingsRoutesConfig.notifications.path,
  UserSettingsRoutesConfig.teamGeneral.path,
  UserSettingsRoutesConfig.teamNotifications.path,
  UserSettingsRoutesConfig.teammates.path,
];

// eslint-disable-next-line max-lines-per-function
export const Routes = () => {
  return (
    <Switch>
      {/* To get rid of an error when react snap prerenders /rpc/404.html */}
      <Route path="/404.html" component={PageNotFound} />
      {featureConfig.isDevUiEnabled && getDevRoutes()}
      <Route
        component={AuthPageContainer}
        exact
        path={authRoutesConfig.auth.path}
      />
      <Route
        component={PricingPageContainer}
        exact
        path={pricingRoutesConfig.pricing.path}
      />
      <Route
        exact
        path={notificationsRoutesConfig.notifications.path}
        component={NotificationsPageContainer}
      />
      <Route
        component={ProjectsParamsResolver}
        exact
        path={projectsRoutesConfig.projects.path}
      />
      <Route
        component={NewProjectPageContainer}
        exact
        path={projectsRoutesConfig.newProject.path}
      />
      <Route
        component={ReferralsPageContainer}
        exact
        path={referralsRoutesConfig.referrals.path}
      />
      <Route
        component={DashboardPageContainer}
        exact
        path={dashboardRoutesConfig.dashboard.path}
      />
      <Route
        component={BillingPageContainer}
        exact
        path={billingRoutesConfig.billing.path}
      />
      <Route
        component={CardPaymentSuccessPageContainer}
        exact
        path={billingRoutesConfig.cardPaymentSuccess.path}
      />
      <Route
        component={CardPaymentFailurePageContainer}
        exact
        path={billingRoutesConfig.cardPaymentFailure.path}
      />
      <Route
        component={PlatformSwaggerPageContainer}
        exact
        path={platformSwaggerRoutesConfig.platformSwagger.path}
      />
      <Route
        component={SwaggerUIPageContainer}
        exact
        path={swaggerUIRoutesConfig.swaggerUI.path}
      />
      <GuardAuthUserSettingsRoute
        component={ConnectWalletCard}
        exact
        path={settingsPaths}
      />
      <GuardTeamInvitationRoute
        exact
        path={UserSettingsRoutesConfig.teamInvitation.path}
      />
      <Route
        component={OAuthPageContainer}
        exact
        path={oAuthRoutesConfig.oAuth.path}
      />
      <Route
        exact
        path={chainsRoutesConfig.chains.path}
        component={ChainsListPageContainer}
      />
      <Route
        component={NewTeamPageContainer}
        exact
        path={teamsRoutesConfig.newTeam.path}
      />
      <Route
        component={TeamsPageContainer}
        exact
        path={teamsRoutesConfig.teams.path}
      />
      <Route
        component={AdvancedApiRoutes}
        exact
        path={AdvancedApiRoutesConfig.advancedApi.path}
      />
      <GuardTelegramConfirmationRoute
        exact
        path={UserSettingsRoutesConfig.telegramConfirmation.path}
      />
      <GuardSlackConfirmationRoute
        exact
        path={UserSettingsRoutesConfig.slackConfirmation.path}
      />
      <GuardEmailConfirmationRoute
        exact
        path={UserSettingsRoutesConfig.emailConfirmation.path}
      />
      <Route
        exact
        path={chainsRoutesConfig.chainDetails.path}
        component={ChainPageContainer}
      />
      <Route component={PageNotFound} />
    </Switch>
  );
};
